<div class="extension-wrapper">
  <div class="extension-header"
       [innerHTML]="'extension.downloadAndInstall' | translate">
  </div>
  <button
    class="extension-button"
    (click)="openExtension()"
  >
    <img
      src="../../../assets/img/extension.png"
      alt="Extension"
      class="extension-image"
    />
    <span class="extension-label">
      Chrome Extension
    </span>
  </button>
</div>
